//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';
import gaApi from 'app/initialization/ga/ga-api';

function openModalAction() {
  return createAction({
    type: GALLERIES_ACTIONS.OPEN_CUSTOMIZE_GALLERY_MODAL,
  });
}

function closeModal() {
  return createAction({
    type: GALLERIES_ACTIONS.CLOSE_CUSTOMIZE_GALLERY_MODAL,
  });
}

function closeLocalizationWarning() {
  return createAction({
    type: GALLERIES_ACTIONS.CLEAR_LOCALIZATION_SAVE_WARNING,
  });
}

function openLocalizationWarning() {
  return createAction({
    type: GALLERIES_ACTIONS.SHOW_LOCALIZATION_SAVE_WARNING,
  });
}

function showCustimisationPanelErrorStatus() {
  return createAction({
    type: GALLERIES_ACTIONS.SHOW_CUSTOMISATIONPANEL_ERROR_STATUS,
  });
}

function hideCustomizationPanelErrorStatus() {
  return createAction({
    type: GALLERIES_ACTIONS.HIDE_CUSTOMISATIONPANEL_ERROR_STATUS,
  });
}

export type GalleriesCustomizationActionType = ReturnType<
  | typeof openModalAction
  | typeof closeModal
  | typeof openLocalizationWarning
  | typeof closeLocalizationWarning
  | typeof showCustimisationPanelErrorStatus
  | typeof hideCustomizationPanelErrorStatus
>;

export const actions = {
  closeLocalizationWarning,
  openLocalizationWarning,
  showCustimisationPanelErrorStatus,
  hideCustomizationPanelErrorStatus,

  closeModal,

  openModal: () => async (dispatch: ReduxDispatch) => {
    dispatch(openModalAction());

    gaApi.recordEvent(
      gaApi.CATEGORY_GALLERIES,
      gaApi.ACTION_GALLERIES_CUSTOMIZE_GALLERY_CTA_CLICKED,
    );
  },
};
